import {
  Classpass,
  DoorDash,
  GetAround,
  GoPuff,
  Uber,
  Uniqlo,
} from '../../../../../Assets/Images/logos'

export const logos = [
  {
    id: 0,
    Icon: Classpass,
  },
  {
    id: 1,
    Icon: DoorDash,
  },
  {
    id: 2,
    Icon: Uber,
  },
  {
    id: 3,
    Icon: GoPuff,
  },
  {
    id: 4,
    Icon: Uniqlo,
  },
  {
    id: 5,
    Icon: GetAround,
  },
]
